module.exports = __webpack_public_path__ + "static/media/arbol.895b2555.svg";